import { baseApi } from "./baseApi";
import { setToken, updateCurrentUser, logout as logoutAction } from "../store/slices/authSlice";

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ username, password }) => ({
        url: "/auth/token",
        method: "POST",
        body: {
          grant_type: "password",
          username,
          password,
        },
        contentType: "application/x-www-form-urlencoded",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data: tokenData } = await queryFulfilled;
          console.log(tokenData);
          dispatch(
            setToken({
              token: tokenData.access_token,
              refreshToken: tokenData.refresh_token || null,
              expiresAt: tokenData.expires_in
                ? Date.now() + tokenData.expires_in * 1000
                : null,
            })
          );

          const userData = await dispatch(
            baseApi.endpoints.getUserInfo.initiate()
          ).unwrap();
          dispatch(updateCurrentUser(userData));
        } catch {} // Error handling is managed by RTK Query
      },
    }),

    getUserInfo: builder.query({
      query: () => ({
        url: "/auth/user-info",
        method: "GET",
      }),
    }),

    logout: builder.mutation({
      query: () => ({
        url: "/auth/logout",
        method: "POST",
        contentType: "application/x-www-form-urlencoded",
      }),
      async onQueryStarted(arg, { dispatch }) {
        dispatch(logoutAction());
      },
    }),

    setUserPassword: builder.mutation({
      query: ({ userId, passwordData }) => ({
        url: `/auth/${userId}/password`,
        method: "POST",
        body: passwordData,
      }),
      invalidatesTags: [],
    }),
  }),
});

export default authApi;
